GoodsWarrantyView = require './views/goods_warranty'

GoodsWarranty =
  init: ({buyButton, goodsWarranty}, done) ->
    return done() unless goodsWarranty?

    model = new Backbone.Model
      bundleCheckoutUrl: goodsWarranty.bundleCheckoutUrl
      buyUrl: buyButton?.buyButtonUrl
    new GoodsWarrantyView {model, goodsWarranty}
    done()

module.exports = GoodsWarranty
